define('../app/fukit/config',['require','exports','module','backbone','underscore','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var Backbone        = require('backbone'),
      _               = require('underscore'),
      Promise         = require('bluebird'),
      VARIABLE_REGEX  = /\${([^}]+)}/g;

  var ConfigModel = Backbone.Model.extend({
    defaults: function() {
      try {
        if (_.isString(window.APP_JSON_CONFIG) && window.APP_JSON_CONFIG.length > 0) {
          return JSON.parse(window.APP_JSON_CONFIG);
        }
      } catch (e) {
        Promise.reject(e);
        return {};
      }
    },

    get: function(attr) {
      var starIndex = String(attr).indexOf('.*');
      if (starIndex >= 0) {
        return this.getAllWithPrefixMatch(attr.slice(0, starIndex), { replacePrefix: true });
      } else {
        var result = Backbone.Model.prototype.get.apply(this, arguments);
        if (!_.isUndefined(result) || String(attr).indexOf('.') < 0) {
          return result;
        }

        // crawl through nested objects
        var splitAttr = String(attr).split('.');
        var subObject = this.get(splitAttr[0]);
        var index = 1;
        while (!_.isUndefined(subObject) && index < splitAttr.length) {
          subObject = subObject[splitAttr[index]];
          index++;
        }

        return subObject;
      }
    },

    getAllWithPrefixMatch: function(prefix, options) {
      var data = {};
      options || (options = {});
      _.each(
        this.keys(),
        function(key) {
          var dataKey = key;
          if (key.indexOf(prefix) === 0) {
            if (options.replacePrefix) {
              dataKey = dataKey.slice(prefix.length);
              if (dataKey[0] === '.') {
                dataKey = dataKey.slice(1);
              }
            }
            data[dataKey] = this.get(key.replace('*', '\\*'));
          }
        },
        this
      );
      return data;
    },
  });

  var config = new ConfigModel();

  config.replaceVariables = function(value) {
    return String(value).replace(VARIABLE_REGEX, function(match, name) {
      return config.get(name);
    });
  };

  config.VARIABLE_REGEX = VARIABLE_REGEX;
  config.ConfigModel = ConfigModel;

  module.exports = config;
});

